var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-layout',[_c('confirmation-modal',{ref:"modal",attrs:{"linkOnCancel":"Landing Page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }